import React from "react";

const MainBanner = ({ electionKeys }) => {
  // console.log("electionKeys", electionKeys);
  return (
    <div
      className="
        h-full 
        
        w-full 
         
      "
    >
      <div className="hidden md:flex">
        <img src={electionKeys?.desktopBannerUrl} />
      </div>
      <div className="flex md:hidden">
        <img src={electionKeys?.mobileBannerUrl} />
      </div>
    </div>
  );
};

export default MainBanner;
